import type { FormDefinition } from '@/core/templates/types'

export default {
  sections: {
    aufgabe: {
      fields: [
        { id: 'aufgabe.bearbeitetVon', control: 'text', readOnly: 'frozen' },
        { id: 'aufgabe.datum', control: 'date', pastYears: 1 },
        { id: 'aufgabe.dokumentation', control: 'text', required: true },
      ],
    },
  },
} satisfies FormDefinition
